const config = {
  apiUrl: '/masterdataservice', // the API is always served relative to frontend
  publicUrl: process.env.PUBLIC_URL || 'http://localhost:3000',
  knowledgeBaseUrl: '/content/kb/', // the knowledge base is served on the same origin as the frontend
  websiteUrl: 'https://www.appcontrol.ai',
};
export default config;
